export enum TypeSales {
  'ambas'= 'ambas',
  'domicilio'= 'domicilio',
  'tienda'= 'tienda'
}
